import React from 'react';
import Loading from '../../components/Loading';

interface DataTableProps<T> {
    data: T[];
    columns: {
        key: string;
        header: string;
        render?: (item: T) => React.ReactNode;
    }[];
    emptyMessage: string;
    isLoading?: boolean;
}

export const DataTable = <T,>({ data, columns, emptyMessage, isLoading = false }: DataTableProps<T>) => {
    const [searchTerm, setSearchTerm] = React.useState('');

    const filteredData = data.filter(item =>
        columns.some(column => {
            const value = column.render ? String(column.render(item)) : String((item as any)[column.key]);
            return value.toLowerCase().includes(searchTerm.toLowerCase());
        })
    );

    return (
        <div>
            <div className="_telastable-filter">
                <input
                    type="text"
                    placeholder="Pesquisar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="_telasfilter-input"
                />
            </div>

            <table className="_telastable">
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key}>{column.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan={columns.length}>
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                            <tr key={index}>
                                {columns.map((column) => (
                                    <td key={`${index}-${column.key}`}>
                                        {column.render ? column.render(item) : (item as any)[column.key]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={columns.length}>
                                {emptyMessage}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
